import { Box, Button, Input, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';
import { editText, editColor } from 'src/store/modules/editText';

interface editCountdownProps {
  menuTitle: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0 0.5rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    padding: '1rem',
    border: 0,
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  },

  textControl: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTop: '1px solid #dddddd',
    backgroundColor: '#e4e4e4'
  },
  countdownContainer: {
    padding: '1rem 0.5rem',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #dddddd'
  },
  closingDate: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    textAlign: 'center'
  },
  dateLabel: {
    color: '#828282',
    fontSize: '0.75rem',
    fontWeight: 400,
    fontFamily: 'Roboto'
  }
}));

const stylesInput: any = {
  padding: 0,
  textAlign: 'center',
  fontFamily: 'Roboto',
  fontSize: '0.875rem',
  fontWeight: 400,
  letterSpacing: '0.015rem'
};

const EditCountdown: FC<editCountdownProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  var text = useSelector((state: RootState) => state.editText.text);
  var color = useSelector((state: RootState) => state.editText.color);

  const {
    refPicker,
    refButton1,
    refButton2,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const handleColorPicker = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const handleColor = c => {
    const newColor = JSON.parse(`{"${type}": "${c.hex}"}`);
    dispatch(editColor({ ...color, ...newColor }));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
    }
  };

  const handleChange = (e: any, t: any) => {
    if (t < e.target.value) return;
    const defaultCountTime = text?.[type];
    const newCountdownName = JSON.parse(
      `{"${e.target.name}": ${
        e.target.value === ''
          ? 0
          : Number(e.target.value.replace(/[^0-9]/g, ''))
      }}`
    );

    const a = JSON.stringify({ ...defaultCountTime, ...newCountdownName });
    const newCountdown = JSON.parse(`{"${type}": ${a}}`);
    dispatch(editText({ ...text, ...newCountdown }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        {menuTitle}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <Box className={classes.countdownContainer}>
          <Box className={classes.closingDate}>
            <Input
              disableUnderline
              inputProps={{
                style: stylesInput
              }}
              name="year"
              value={text?.[type]?.year}
              onChange={e => handleChange(e, 2034)}
              onKeyDown={handleKeyDown}
            ></Input>
            <span className={classes.dateLabel}>Year</span>
          </Box>
          <Box className={classes.closingDate}>
            <div
              style={{
                display: 'flex',
                fontSize: '0.875rem',
                color: '#828282'
              }}
            >
              /
              <Input
                disableUnderline
                inputProps={{
                  style: stylesInput
                }}
                name="month"
                value={text?.[type]?.month}
                onChange={e => handleChange(e, 12)}
                onKeyDown={handleKeyDown}
              ></Input>
              /
            </div>
            <span className={classes.dateLabel}>Month</span>
          </Box>
          <Box className={classes.closingDate}>
            <Input
              disableUnderline
              inputProps={{
                style: stylesInput
              }}
              name="date"
              value={text?.[type]?.date}
              onChange={e => handleChange(e, 31)}
              onKeyDown={handleKeyDown}
            ></Input>
            <span className={classes.dateLabel}>Date</span>
          </Box>
          <Box className={classes.closingDate}>
            <Input
              disableUnderline
              inputProps={{
                style: stylesInput
              }}
              name="hour"
              value={text?.[type]?.hour}
              onChange={e => handleChange(e, 23)}
              onKeyDown={handleKeyDown}
            ></Input>
            <span className={classes.dateLabel}>Hour</span>
          </Box>
          :
          <Box className={classes.closingDate}>
            <Input
              disableUnderline
              inputProps={{
                style: stylesInput
              }}
              name="min"
              value={text?.[type]?.min}
              onChange={e => handleChange(e, 59)}
              onKeyDown={handleKeyDown}
            ></Input>
            <span className={classes.dateLabel}>Min</span>
          </Box>
        </Box>
      </div>

      <div>
        <Box className={classes.boxWrapper}>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <Button
              ref={refButton1}
              onClick={handleColorPicker}
              className={classes.buttonWrapper}
            >
              <img
                alt="color"
                src={colorRectangle}
                className={classes.buttonImage}
              />
            </Button>
            <Button
              ref={refButton2}
              style={{
                maxWidth: '1.25rem',
                minWidth: '1.25rem',
                maxHeight: '1.25rem',
                minHeight: '1.25rem',
                padding: 0
              }}
              onClick={handleColorPicker}
            >
              <div
                style={{
                  width: '1.25rem',
                  height: '1.25rem',
                  backgroundColor: color[type],
                  border: `1px solid #D9D9D9`,
                  borderRadius: 999
                }}
              />
            </Button>
            <div className={classes.colorBox}>{color[type]?.toUpperCase()}</div>
          </div>
        </Box>
        {isComponentVisible && (
          <div ref={refPicker} style={{ width: '100%', marginTop: '1rem' }}>
            <ChromePicker
              color={color[type]}
              onChange={handleColor}
              disableAlpha={true}
              width="100%"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditCountdown;
